
import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import * as _ from 'lodash';

// config
import { appConfig } from '../../../config/app-config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// components
import { navigationConfig } from '../../config/navigation.config';
import { INavElementsNode } from '../../model/nav-elements-nodegroup';
import { NavigationService } from '../../service/navigation.service';
import { UiMessageSnackService } from '../../../core/components/message-snack/service/message-snack.service';
import { INavNewEdgeAndElement } from '../../model/nav-new-edge-element.interface';
import { navigationStoreSchema } from '../../store/actions';
import { INavConfig } from '../../store/store';
import { LoadingphaseService } from '../../service/loadingphase.service';

@Component({
   selector: 'app-nav-create-element2',
   templateUrl: './nav-create-element2.html',
   styleUrls: ['./nav-create-element2.scss']
})
export class NavCreateElement2Component {

   // node1 - in UI selectierter Node
   public selectedNode: INavElementsNode = null;

   // title
   public title = '';
   public subtitle = '';

   // button text
   public cancelButtonText = 'ABBRECHEN';
   public okButtonText = 'SPEICHERN';
   private showCancelButton = true;

   // form
   public createElementForm: FormGroup = new FormGroup({});
   public selectCtrl1Name = 'selectCtrl1Name';
   public selectCtrl2Name = 'selectCtrl2Name';

   // entries for selectCtrl1Name
   public selectCtrl1Pairs: { value: string, uiMessage: string, dir: string }[] = [];
   public selectCtrl2Pairs: { value: string, uiMessage: string }[] = [];

   // config
   private _config: INavConfig = null;
   private _configEdgeDef: any = null;
   private _configDict: any = null;

   // selection in Control
   private _selectedValueCtrl1 = '';
   private _selectedValueCtrl2 = '';

   // loading data
   public set _loadingPhase(value: boolean) {
      this._loadingphaseService.setLoadingphase(value, 'nav_create_element');
   }

   // Observables from store
   @select((s: IAppState) => s.navigationState.schema) navSchema$;

   constructor(
      private _store: NgRedux<IAppState>,
      private _navigationService: NavigationService,
      private _messageSnackService: UiMessageSnackService,
      public dialogRef: MatDialogRef<NavCreateElement2Component>,
      private _loadingphaseService: LoadingphaseService,
   ) { }

   public updateView() {
      // create form
      this.createElementForm = new FormGroup({
         selectCtrl1Name: new FormControl(''),
         selectCtrl2Name: new FormControl('')
      });

      // sanity
      const config: INavConfig = this._store.getState().navigationState.config;
      if (!config.hasOwnProperty('dictionary')) {
         console.warn('Dictionary in config nicht vorhanden');
         return;
      }
      if (!config.hasOwnProperty('edgeDefinitions')) {
         console.warn('EdgeDefinitions in Config nicht vorhanden');
         return;
      }

      // keep config
      this._config = config;
      this._configDict = config['dictionary'];
      this._configEdgeDef = config['edgeDefinitions'];

      // fill controls
      this.onLazyInit();

      // -- value change of form ------------------------------------------------------------------
      this.createElementForm.valueChanges.subscribe(val => {

         // not initialized -> ignore
         if (!val.selectCtrl1Name) {
            return;
         }

         // control 1 hat geändert
         if (this._selectedValueCtrl1 !== val.selectCtrl1Name) {

            // reset detail dialog
            this._store.dispatch(navigationStoreSchema(null));
            this.showCancelButton = true;

            // save old selected value
            this._selectedValueCtrl1 = val.selectCtrl1Name;

            // reset selectCtrl2Pairs
            this.selectCtrl2Pairs = [];
            this._selectedValueCtrl2 = '';

            const type = this._configEdgeDef[this.selectedNode.group];
            const edge = type[this._selectedValueCtrl1.split('.')[0]];
            const possibleElems = edge[this._selectedValueCtrl1.split('.')[1]];

            let dictItem: any = null;

            possibleElems.forEach(elemType => {

               // Anzeige wert für edge
               dictItem = _.find(this._configDict, item => item.key === elemType);

               this.selectCtrl2Pairs.push({
                  uiMessage: dictItem.long,
                  value: elemType
               });
            });

         } else if (this._selectedValueCtrl2 !== val.selectCtrl2Name) {
            // save old selected value
            this._selectedValueCtrl2 = val.selectCtrl2Name;

            // hide cancel button of dialog
            this.showCancelButton = false;

            // load schema
            this.onLoadSchema(this._selectedValueCtrl2);
         }

      });
   }

   // ----------------------------------------------------------------------------------------------
   // -- onInit/onDestroy
   // ----------------------------------------------------------------------------------------------
   private onLazyInit(): void {

      try {
         let dictItem: any = null;

         // fülle select für kanten
         if (!this._configEdgeDef[this.selectedNode.group]) {
            console.warn('EdgeDefinition für Element nicht gefunden');
            return;
         }

         // reset
         this.createElementForm.reset({
            selectCtrl1Name: '',
            selectCtrl2Name: ''
         });
         this.selectCtrl1Pairs = [];
         this.selectCtrl2Pairs = [];
         this._selectedValueCtrl1 = '';
         this._selectedValueCtrl2 = '';

         // über alle edges für eine element z.B. Meldung -> IstIn, LoestAus, etc
         const edges = this._configEdgeDef[this.selectedNode.group];
         /* tslint:disable */
         for (let edge in edges) {

            // TODO: Muss in die Konfiguration ausgelagtert werden!
            // Am Besten zusammen mit der Sonderbehandlung in der Liste!
            if (edge === "Schaltet") {
               continue;
            }

            // Anzeige wert für edge
            dictItem = _.find(this._configDict, item => item.key === edge);

            // edge fwd
            if (edges[edge].to) {
               this.selectCtrl1Pairs.push({
                  uiMessage: dictItem.fwd,
                  value: edge + '.to',
                  dir: 'to'
               });
            }

            // edge bkwd
            if (edges[edge].from) {
               this.selectCtrl1Pairs.push({
                  uiMessage: dictItem.bkwd,
                  value: edge + '.from',
                  dir: 'from'
               });
            }
         }
         /* tslint:enable */

      } catch (e) {
         console.error(e);
      }
   }

   // ----------------------------------------------------------------------------------------------
   // -- Event handler - View
   // ----------------------------------------------------------------------------------------------
   public onCancel() {
      this.dialogRef.close(null);
   }

   // ----------------------------------------------------------------------------------------------
   // -- Event handler - detail view
   // ----------------------------------------------------------------------------------------------
   public onLoadSchema(elementType: string): void {

      this._loadingPhase = true;

      // -->>ASY
      this._navigationService.loadSchema(
         elementType
      )
         .then((boolResultASY: IBoolResult) => {
            this._loadingPhase = false;

            // result available
            if (boolResultASY.result) {
               return;
            }

            // no data
            this._messageSnackService.showSnackWarning(boolResultASY.message.message, 'NavSearchGraphViewComponent');
         })
         .catch((err: ErrorMessage) => {
            this._loadingPhase = false;
            this._messageSnackService.showSnackError(err.message, 'NavSearchGraphViewComponent');
         });
   }

   public onCancelDetailView() {
      this.dialogRef.close(null);
   }

   public onSubmitDetailView(data: any) {
      this._loadingPhase = true;
      const element = {
         fromID: this.selectedNode.id,
         edgeType: this._selectedValueCtrl1.split('.')[0],
         direction: this._selectedValueCtrl1.split('.')[1],
         elemType: this._selectedValueCtrl2,
         data: data
      };

      this._navigationService.validateDocument(
         {
            collection: element.elemType,
            document: element.data,
         }
      ).then((v) => {
         this._loadingPhase = false;
         if (!v.error) {
            this.dialogRef.close(element);
            return;
         }
         const schema = this._store.getState().navigationState.schema;
         const layout = schema.layout;
         if (layout.collection !== element.elemType) {
            this._messageSnackService.showSnackError('Interner Fehler');
            return;
         }
         const property = layout.elements.find((e) =>
            e.scope.$ref === `#/properties/${v.error.property}`
         );
         this._messageSnackService.showSnackError(`Das Feld '${property ? property.label : v.error.property}' 
         entspricht nicht den Anforderungen!`);
      }).catch(() => this._loadingPhase = false);

   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/compv/nav-create-element2/nav-create-element2.ts